import { isSandbox } from '@/std/url';

const API_LOCAL = 'http://localhost:100';
const API_SAND = 'https://sandbox.tecno.mobi';
const API_PROD = 'https://api.tecno.mobi';

function getBaseUrl() {
    const environment = import.meta.env.VITE_ENVIRONMENT;

    if (environment === 'local') {
        return API_LOCAL;
    }

    if (environment === 'production') {
        return API_PROD;
    }

    return isSandbox() ? API_SAND : API_PROD;
}

const baseUrl = getBaseUrl();

export const API_URL = `${baseUrl}/api/v1`;
